export const API_KEY = 'testApiKey';
export const API_SECRET_KEY = 'testApiSecretKey';
export const APP_URL = 'https://my-test-app.myshopify.io';
export const TEST_SHOP_NAME = 'test-shop';
export const TEST_SHOP = `${TEST_SHOP_NAME}.myshopify.com`;
export const SHOPIFY_HOST = `admin.shopify.com/store/${TEST_SHOP_NAME}`;
export const BASE64_HOST = Buffer.from(SHOPIFY_HOST).toString('base64');
export const USER_ID = 12345;
